import React from "react";
import { useLang } from "../i18n/LanguageContext";

export default function LanguageToggle({ dark = false }) {
  const { lang, setLang } = useLang();
  const base = dark ? "border-white/20 text-parchment/70" : "border-gold/40 text-crimson";
  const active = dark ? "bg-gold text-crimson" : "bg-crimson text-parchment";
  return (
    <div className={`inline-flex overflow-hidden rounded-full border text-xs font-semibold ${base}`} data-testid="lang-toggle">
      {[["en", "EN"], ["tw", "TWI"]].map(([k, l]) => (
        <button key={k} onClick={() => setLang(k)} data-testid={`lang-${k}`}
          className={`px-3 py-1 transition-colors ${lang === k ? active : "hover:bg-black/5"}`}>{l}</button>
      ))}
    </div>
  );
}
